/* ==========================================================================
   DIANDA TRAVEL — City / Destination Hub Page 交互脚本
   页面定位：Destination Hub（目的地内容中心）
   ==========================================================================
   设计原则：
   - 无依赖、轻量
   - 只做类切换 / max-height 过渡，避免触发重排
   - 所有查询都限定在 .dd-city 内，避免污染其他页面
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('dd-city-faq');
  
  if (!root) return;

  /* ------------------------------------------------------------------
     1. FAQ 手风琴（纯 CSS max-height 过渡 + 无障碍属性）
     ------------------------------------------------------------------ */
  root.querySelectorAll('.dd-faq__item').forEach(function (item) {
    var btn = item.querySelector('.dd-faq__q');
    var panel = item.querySelector('.dd-faq__a');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      // 关闭同组其它项（手风琴：同时只展开一个）
      var list = item.closest('.dd-faq__list');
      if (list) {
        list.querySelectorAll('.dd-faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var openPanel = openItem.querySelector('.dd-faq__a');
            if (openPanel) openPanel.style.maxHeight = null;
            var openBtn = openItem.querySelector('.dd-faq__q');
            if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        panel.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
